// Sends logs via api request
import { ClientLogger } from '@Praia-Health/spi-common-utils/browser';
import { LoggerContext } from '@Praia-Health/spi-common-utils/types';

export class ApiRequestLogger extends ClientLogger {
    constructor(context?: LoggerContext, maxMessageLength?: number) {
        super({
            context: context || {},
            maxMessageLength: maxMessageLength,
        });
        this.addContext({
            '@app_name': 'SPI.PatientIdentityPortal',
            '@type': 'log',
            pathName: window.location.pathname,
        });
    }
}
